import React from "react";
import Breadcrumb from "../components/breadcrumb/Breadcrumb";

const posts = [
  {
    title: "Why practical learning matters in tech careers",
    date: "April 12, 2026",
    excerpt:
      "Hands-on projects help learners move from theory to confidence faster and build job-ready skills with less friction.",
  },
  {
    title: "How to build a strong digital portfolio",
    date: "March 28, 2026",
    excerpt:
      "A focused portfolio can help you stand out, showcase real work, and make your learning journey easier to measure.",
  },
  {
    title: "The future of work starts with digital skills",
    date: "March 08, 2026",
    excerpt:
      "From automation to entrepreneurship, the ability to adapt and learn continuously is becoming a core advantage.",
  },
];

const events = [
  {
    title: "Open House & Career Guidance Session",
    date: "May 18, 2026",
    time: "10:00 AM – 12:00 PM",
    location: "Virtual / Online",
  },
  {
    title: "Web Development Bootcamp Orientation",
    date: "May 24, 2026",
    time: "2:00 PM – 4:00 PM",
    location: "Nairobi Hub",
  },
  {
    title: "Digital Skills Meetup",
    date: "June 02, 2026",
    time: "5:30 PM – 7:30 PM",
    location: "Innovation Center",
  },
];

const BlogEvents = () => {
  return (
    <>
      <Breadcrumb current="Blog & Events" />
      <section className="py-5" aria-label="Blog and events page">
        <div className="container">
          <div className="text-center mb-5">
            <h1 className="fw-bold mb-3">Blog & Events</h1>
            <p className="mx-auto text-muted" style={{ maxWidth: "700px" }}>
              Explore practical stories, learning insights, and upcoming sessions designed to help you grow your skills and confidence.
            </p>
          </div>

          <div className="row g-4">
            <div className="col-lg-7">
              <h2 className="fw-bold mb-4">Latest articles</h2>
              <div className="d-flex flex-column gap-3">
                {posts.map((post) => (
                  <article key={post.title} className="card border-0 shadow-sm p-4 h-100">
                    <p className="text-primary fw-semibold mb-2">{post.date}</p>
                    <h3 className="h4 fw-bold mb-3">{post.title}</h3>
                    <p className="mb-0 text-muted">{post.excerpt}</p>
                  </article>
                ))}
              </div>
            </div>

            <div className="col-lg-5">
              <h2 className="fw-bold mb-4">Upcoming events</h2>
              <div className="d-flex flex-column gap-3">
                {events.map((event) => (
                  <div key={event.title} className="card border-0 shadow-sm p-4 h-100">
                    <p className="text-primary fw-semibold mb-2">{event.date}</p>
                    <h3 className="h5 fw-bold mb-2">{event.title}</h3>
                    <ul className="list-unstyled mb-0 text-muted">
                      <li><strong>Time:</strong> {event.time}</li>
                      <li><strong>Location:</strong> {event.location}</li>
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogEvents;
